import React from "react";
import { CiBoxList,CiBoxes,CiCirclePlus,CiGrid41,CiFilter,CiAvocado,CiBeaker1 } from "react-icons/ci";
import { Link } from "react-router-dom";

import "./DashboardSideBar.scss";

const DashboardSideBar = ({ active }) => {
  return (
    <div className="container">
      <div className={`navItem ${active === 1 ? "active" : ""}`}>
        <Link to="/dashboard" className={`navLink ${active === 1 ? "active" : ""}`}>
          <CiGrid41  className="navIcon" />
          <h5 className="navText">Головна</h5>
        </Link>
      </div>

      <div className={`navItem ${active === 2 ? "active" : ""}`}>
        <Link to="/dashboard-products" className={`navLink ${active === 2 ? "active" : ""}`}>
          <CiBoxes  className="navIcon" />
          <h5 className="navText">Всі продукти</h5>
        </Link>
      </div>

      <div className={`navItem ${active === 3 ? "active" : ""}`}>
        <Link to="/dashboard-create-category" className={`navLink ${active === 3 ? "active" : ""}`}>
          <CiBoxList  className="navIcon" />
          <h5 className="navText">Категорії</h5>
        </Link>
      </div>

      <div className={`navItem ${active === 4 ? "active" : ""}`}>
        <Link to="/dashboard-filters" className={`navLink ${active === 4 ? "active" : ""}`}>
          <CiFilter  className="navIcon" />
          <h5 className="navText">Фільтри</h5>
        </Link>
      </div>

      <div className={`navItem ${active === 5 ? "active" : ""}`}>
        <Link to="/dashboard-create-product" className={`navLink ${active === 5 ? "active" : ""}`}>
          <CiCirclePlus  className="navIcon" />
          <h5 className="navText">Створити продукт</h5>
        </Link>
      </div>
      <div className={`navItem ${active === 6 ? "active" : ""}`}>
        <Link to="/dashboard-parentcolors" className={`navLink ${active === 6 ? "active" : ""}`}>
          <CiAvocado   className="navIcon" />
          <h5 className="navText">Батьківські Кольори</h5>
        </Link>
      </div>
      <div className={`navItem ${active === 7 ? "active" : ""}`}>
        <Link to="/dashboard-colors" className={`navLink ${active === 7 ? "active" : ""}`}>
          <CiBeaker1    className="navIcon" />
          <h5 className="navText"> Кольори</h5>
        </Link>
      </div>
    </div>
  );
};

export default DashboardSideBar;
